import React from 'react'
import { trans } from '../../../../_providers/Translation'
import DateRange from '@/components/partials/DateRange'

function FilterReservations(props) {

    const handleSearch = e => {
        let name = e.target.name
        let val = e.target.value

        props.handleSearch(name, val)
    }

    const handleClearFilters = () => {
        props.handleSearch('search', '')
        props.handleSearch('status', '')
        props.handleSearch('date', '')
        props.handleSearch('deadline', '')
        props.handleSearch('paid_status', '')
    }

    return (
        <div className="filter-standard">
            <div className="col">
                <input
                    type="search"
                    name="search"
                    value={props.filter.search}
                    onChange={handleSearch}
                    placeholder={trans('labels.search')}
                />
            </div>
            <div className="col">
                <select
                    name="status"
                    value={props.filter.status}
                    onChange={handleSearch}
                >
                    <option value="" selected>
                        {trans('filters.status')}
                    </option>
                    <option value="pending">
                        {trans('random.pendding')}
                    </option>
                    <option value="closed">
                        {trans('random.closed')}
                    </option>
                </select>
            </div>

            <div className="col">
                <DateRange
                    startDate={props.filter.date}
                    endDate={props.filter.deadline}
                    onStartDateChange={(date) => {
                        props.handleSearch('date', date)
                    }} onEndDateChange={(date) => {
                        props.handleSearch('deadline', date)
                    }}
                />

            </div>

            <div className="col">
                <select
                    name="paid_status"
                    value={props.filter.paid_status}
                    onChange={handleSearch}
                >
                    <option value="" selected>
                        {trans('selfEmployed.paidStatus.title')}
                    </option>
                    <option value="paid">
                        {trans('selfEmployed.paidStatus.paid')}
                    </option>
                    <option value="not_paid">
                        {trans('selfEmployed.paidStatus.notPaid')}
                    </option>
                </select>
            </div>

            <div className='col'>
                <button type='button' className='button-clear-filter' onClick={handleClearFilters}>
                    Изчистване
                </button>
            </div>
        </div>
    )
}

export default React.memo(FilterReservations, (prev, next) => {
    return JSON.stringify(prev) === JSON.stringify(next)
})